// RequireAuth — guard de rutas.
//
// Envuelve rutas que exigen sesión iniciada. Si el usuario NO está
// autenticado, redirige a /login y le guarda a la ruta destino en
// location.state.from para que después del login vuelva a donde iba.
//
// Uso:
//   <Route path="/admin" element={<RequireAuth><AdminPage/></RequireAuth>} />
//
// Mientras el AuthProvider está hidratando desde localStorage (loading=true)
// mostramos un spinner para evitar un flash a /login que dispararía redirect
// aunque el usuario sí tuviera sesión guardada.

import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AppContext';

export default function RequireAuth({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    // Estado breve mientras se lee localStorage.
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        minHeight: '50vh', color: '#666',
      }}>
        Cargando sesión…
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
